import React from "react";
import { useState, useEffect } from "react";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { AddressBookController } from "@/app/core/base/controllers/AddressBookController";
import { Dropdown } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import ReactInputMask from "react-input-mask";
import { UserTypeObj } from "@/app/core/util/helpers/UserHelper";

export default function BrokerStep({ broker, reportBroker }) {
    const date = new Date();
    const [change, setChange] = useState(date.getTime());
    const [data, setData] = useState({});
    const [query, setQuery] = useState("");
    const [addressBook, setAddressBook] = useState([]);

    useEffect(() => {
        console.log("O que chegou", broker)
        if (broker) {
            setData(broker);
        } else {
            setData({});
        }
        loadAddressBook()
    }, [broker])

    useEffect(() => {
        loadAddressBook()
    }, [])

    useEffect(() => {
        reportBroker(data);
    }, [data])

    function loadAddressBook() {
        AddressBookController.Get(res => setAddressBook(res))
    }

    function handleChange(evt, type) {
        console.log("Será", evt);
        setData(OnDataChange(data, evt, type))

        console.log("Será", OnDataChange(data, evt, type));
    }

    return (
        <div className="">
            <div className="block block-bordered block-rounded bg-light">
                <div className="block-header">
                    <div className="block-title">
                        {Translate(Message.Broker)}
                    </div>
                    <div className="block-tools d-md-flex justify-content-md-between align-items-md-center">
                        {addressBook && addressBook.length > 0 ?
                            <Dropdown style={{ zIndex: 21 }} drop="left">
                                <Dropdown.Toggle variant="light">
                                    <i className="fa fa-search" /> Procurar
                                </Dropdown.Toggle>
                                <Dropdown.Menu style={{ width: 450 }}>
                                    <Typeahead
                                        options={addressBook}
                                        labelKey={(option) => `${option.name} - ${option.state} - ${option.country}`}
                                        onSearch={(q) => setQuery(q)}
                                        name="country_code"
                                        placeholder="Selecionar"
                                        id={`coleta-responsavel`}
                                        onChange={(selected) => {
                                            if (selected[0] !== undefined || selected !== null) {
                                                setData({ ...data, ...selected[0] })
                                            }
                                        }} />
                                </Dropdown.Menu>
                            </Dropdown>
                            : ""}
                    </div>
                </div>
                <div className="block-content row bg-white">
                    <div className={"form-group col-sm-4"}>
                        <span>*{Translate(Message.RecipientName)}</span>
                        <input type="text" className="form-control" name="name" key="namedata" placeholder="Ex: Empresa LTDA ou Jhon Doe" value={data && data.name} onChange={evt => handleChange(evt)} />
                    </div>
                    {/* <div className={"form-group col-md-6"}>
                        <span>*{Translate(Message.Responsible)}</span>
                        <input type="text" className="form-control" name="responsibleName" key="namedata" placeholder="Ex: Jhon Doe" value={data && data.responsibleName} onChange={evt => handleChange(evt)} />
                    </div> */}
                    <div className={"form-group col-sm-4"}>
                        <span>E=mail</span>
                        <input type="text" className="form-control" name="email" key="email" placeholder="Ex: user@email.com" value={data && data.email} onChange={evt => handleChange(evt)} />
                    </div>
                    <div className={"form-group col-sm-4"}>
                        <span>*{Translate(Message.Phone)}</span>
                        <ReactInputMask
                            mask={"99 99999-9999999999"}
                            maskChar=""
                            type="text"
                            className="form-control"
                            id="advanced-filter-document"
                            name="phone"
                            value={data && data.phone}
                            onChange={(event) => {
                                handleChange({
                                    target: {
                                        name: "phone",
                                        value: event.target.value.replace(/\D/g, ""),
                                    },
                                });
                            }}
                        />
                    </div>
                    {/* <div className="col-12">
                        <div className="form-group">
                            <label className="d-block">Tipo</label>
                            <div className="custom-control custom-radio custom-control-inline">
                                <input type="radio" className="custom-control-input" id="example-rd-custom-inline9"
                                    name="personTypeBroker"
                                    checked={data && data.personType == UserTypeObj.Person ? true : false}
                                    onChange={evt => setData({ ...data, personType: UserTypeObj.Person })}
                                />
                                <label className="custom-control-label" for="example-rd-custom-inline9">{Translate(Message.PhysicalPerson)}</label>
                            </div>
                            <div className="custom-control custom-radio custom-control-inline">
                                <input type="radio" className="custom-control-input" id="example-rd-custom-inline10"
                                    name="personTypeBroker"
                                    checked={data && data.personType == UserTypeObj.LegalPerson ? true : false}
                                    onChange={evt => setData({ ...data, personType: UserTypeObj.LegalPerson })}
                                />
                                <label className="custom-control-label" for="example-rd-custom-inline10">{Translate(Message.LegalPerson)}</label>
                            </div>
                        </div>

                    </div> */}
                    {/* {data && data.isNational ?
                        <div className="col-md-6">
                            {data && data.personType == UserTypeObj.Person ?
                                <div className="form-group">
                                    <span>*{Translate(Message.Id)}</span>
                                    <input
                                        mask="999.999.999-99"
                                        maskChar=""
                                        type="text"
                                        className="form-control"
                                        id="advanced-filter-document"
                                        name="document"
                                        value={data && data.document}
                                        placeholder="999.999.999-99"
                                        onChange={(event) => {
                                            handleChange({
                                                target: {
                                                    name: "document",
                                                    value: event.target.value.replace("/\D/g", ""),
                                                },
                                            });
                                        }}
                                    />
                                </div>
                                :
                                <div className="form-group">
                                    <span>*{Translate(Message.TaxId)}</span>
                                    <input
                                        mask="99.999.999/9999-99"
                                        maskChar=""
                                        type="text"
                                        className="form-control"
                                        id="advanced-filter-document"
                                        name="document"
                                        value={data && data.document}
                                        placeholder="99.999.999/9999-99"
                                        onChange={(event) => {
                                            handleChange({
                                                target: {
                                                    name: "document",
                                                    value: event.target.value.replace("/\D/g", ""),
                                                },
                                            });
                                        }}
                                    />
                                </div>
                            }
                        </div>
                        :
                        <div className="form-group col-md-6">
                            <span>*{Translate(Message.TaxId)}</span>
                            <input
                                mask="99.999.999/9999-99"
                                maskChar=""
                                type="text"
                                className="form-control"
                                id="advanced-filter-document"
                                name="document"
                                value={data && data.document}
                                placeholder="99.999.999/9999-99"
                                onChange={evt => handleChange(evt)}
                            />
                        </div>
                    } */}
                    {/* {data && data.personType == UserTypeObj.Person ?
                        <div className="form-group col-md-6">
                            <span>*{Translate(Message.Id)}</span>
                            <input
                                mask="99.999.999-9"
                                maskChar=""
                                type="text"
                                className="form-control"
                                id="advanced-filter-document"
                                name="stateTaxId"
                                value={data && data.stateTaxId}
                                placeholder=""
                                onChange={(event) => {
                                    handleChange({
                                        target: {
                                            name: "stateTaxId",
                                            value: event.target.value.replace(/\D/g, ""),
                                        },
                                    });
                                }}
                            />
                        </div>
                        :
                        <div className="form-group col-md-6">
                            <span>*{Translate(Message.StateTaxId)}</span>
                            <input
                                className="form-control"
                                id="advanced-filter-document"
                                name="stateTaxId"
                                value={data && data.stateTaxId}
                                placeholder=""
                                onChange={(event) => handleChange(event)}
                            />
                        </div>
                    } */}
                </div>
            </div>
        </div>
    )
}